function DashboardActiveMainBrakeBias({value}) {
    const formattedBias = (rawBias) => {
        const numericBias = parseFloat(rawBias);
        
        if (isNaN(numericBias) || rawBias <= 0) return "0.0";

        let val = parseFloat((Math.floor(numericBias * 10) / 10).toFixed(1));
        if ((val * 10) % 2 !== 0) {
            val += 0.1;
        }

        return (Math.floor(val * 10) / 10).toFixed(1);
    };

    return (
        <div className="mt-auto">
            <div className="rounded bg-[#111a22] p-3 border border-[#324d67] flex items-center justify-between">
                <span className="text-xs font-bold uppercase">Brake Bias</span>
                <div className="flex items-center gap-2">
                    <span className="text-xl font-black text-acc-yellow italic">{formattedBias((value["brake-bias"]*100))}%</span>
                </div>
            </div>
        </div>
    );
}

export default DashboardActiveMainBrakeBias;